export default __webpack_public_path__ + "static/media/bg-dark1.e15d6213.jpg";